import React, { useEffect, useState } from 'react';
import Headroom from 'react-headroom';
import { Flex, Box, Text, Image } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { Link, useRoute } from 'wouter';
import ProfilePopover from './ProfilePopover';
import { impersonateStyles } from '../../helpers/chakraSelect';
import nextonIcon from '../../images/nexton-icon.svg';

import { useDispatch, useTrackedState } from '../../config/store';

function ActiveLink(props) {
  const { href, children } = props;
  const [isActive] = useRoute(href);
  return (
    <Link {...props}>
      <Box
        h='100%'
        fontSize='14px'
        fontWeight='600'
        color='#337BFF'
        cursor='pointer'
        textDecor='underline'
        fontFamily='Inter'
        _hover={{
          backgroundColor: 'gray.50',
        }}
        bg={isActive ? 'gray.50' : ''}>
        <Flex alignItems='center' h='100%' p='24px'>
          <Text>{children}</Text>
        </Flex>
      </Box>
    </Link>
  );
}

function Header() {
  const state = useTrackedState();
  const dispatch = useDispatch();

  const curatedInterviewersList = () => {
    const curatedArray = [];

    if (state.interviewers && state.interviewers?.length !== 0) {
      state.interviewers.map(interviewer =>
        curatedArray.push({
          value: interviewer.name,
          label: interviewer.name,
          imageUrl: interviewer.imageUrl,
          zohoId: interviewer.zohoId,
        }),
      );
    }
    return curatedArray;
  };

  const [interviewersList, setInterviewersList] = useState([]);
  useEffect(() => setInterviewersList(curatedInterviewersList()), [state.interviewers]);

  const handleGetInterviews = props => {
    dispatch({
      type: 'RESETTED_INTERVIEWS_FILTERS',
    });

    dispatch({
      type: 'GET_INTERVIEWS_PAGINATION_PARAMS',
      token: state.user.token,
      page: 1,
      interviewStatusFilter: 'All Interviews',
      interviewerId: props?.zohoId,
    });
  };

  return (
    <Headroom style={{ zIndex: 3 }}>
      <Box bg='white' boxShadow='0px 20px 20px -14px rgba(161, 161, 161, 0.160047)'>
        <Flex alignItems='center' height='80px' maxWidth='1366px' mx='auto' px='20px'>
          <Link href='/interviews'>
            <Image src={nextonIcon} cursor='pointer' alt='Nexton Logo' mr='32px' maxWidth='38px' maxHeight='42px' />
          </Link>
          <Flex justifyContent='space-between' alignItems='center' h='100%' w='100%'>
            <Flex h='100%'>
              <Box>
                <ActiveLink href='/interviews'>Interview List</ActiveLink>
              </Box>
            </Flex>
            <Flex alignItems='center'>
              {state.user && state.user.impersonateAllowed && (
                <Box minWidth='258px' mr='24px'>
                  <Select
                    placeholder={'\u00A0Impersonate...'}
                    closeMenuOnSelect
                    chakraStyles={impersonateStyles}
                    options={interviewersList}
                    onChange={handleGetInterviews}
                    isClearable
                  />
                </Box>
              )}

              <ProfilePopover />
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </Headroom>
  );
}

export default Header;
